import { useQuery } from "@tanstack/react-query";
import { useAxios } from "../../../api/axios";
import { useTranslation } from "react-i18next";

export const useSFToken = () => {
  const axios = useAxios();
  const { t } = useTranslation();
  let urlKey = `${t("SFToken")}`;
  
  const { data, refetch, isLoading } = useQuery({
    queryKey: [`sf-token`],
    queryFn: async () => {
      const res = await axios.get(urlKey);
      localStorage.setItem("salesforceAccessToken", res.data.data.accessToken);
      return res.data;
    },
  });

  return { data: data?.data, refetch, isLoading };
};
